/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Diet_BreakfastInputs */

const en_platform_diet_breakfast = /** @type {(inputs: Platform_Diet_BreakfastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breakfast`)
};

const pl_platform_diet_breakfast = /** @type {(inputs: Platform_Diet_BreakfastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śniadanie`)
};

/**
* | output |
* | --- |
* | "Breakfast" |
*
* @param {Platform_Diet_BreakfastInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_diet_breakfast = /** @type {((inputs?: Platform_Diet_BreakfastInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Diet_BreakfastInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_diet_breakfast(inputs)
	return en_platform_diet_breakfast(inputs)
});